import { apiFetch } from '@/lib/api'

const BASE = '/api/admin/ai-team'

export type MemoryKind = 'fact' | 'rule' | 'allow'

export interface MemoryItem {
  id: number
  kind: MemoryKind
  kind_label: string
  text: string
  area: string
  area_label: string
  source: 'owner' | 'learned' | 'setup'
  source_label: string
  agent: { key: string; name: string } | null
  active: boolean
  tool_name: string
  updated_at: string
  created_at: string
}

export interface SetupQuestion {
  id: string
  question: string
  options: string[]
  area: string
  multi: boolean
  answered: boolean
}

export interface SetupStatus {
  questions: SetupQuestion[]
  answered: number
  total: number
}

export interface MemoryList {
  items: MemoryItem[]
  setup: SetupStatus
  areas: Array<{ key: string; label: string }>
}

export const fetchMemory = () => apiFetch<MemoryList>(`${BASE}/memory/`)

export const addMemory = (body: { text: string; kind: 'fact' | 'rule'; area: string }) =>
  apiFetch<MemoryItem>(`${BASE}/memory/`, { method: 'POST', body })

export const updateMemory = (
  id: number,
  body: Partial<{ text: string; kind: 'fact' | 'rule'; area: string; active: boolean }>
) => apiFetch<MemoryItem>(`${BASE}/memory/${id}/`, { method: 'PUT', body })

export const deleteMemory = (id: number) => apiFetch(`${BASE}/memory/${id}/`, { method: 'DELETE' })

export const saveSetup = (answers: Record<string, string | string[]>) =>
  apiFetch<{ saved: number; setup: SetupStatus }>(`${BASE}/memory/setup/`, {
    method: 'POST',
    body: { answers }
  })

export type InboxTab = 'needs' | 'info' | 'done'

export interface InboxItem {
  key: string
  kind: string
  kind_label: string
  id: number
  title: string
  summary: string
  tab: InboxTab
  area: string
  agent: { key: string; name: string } | null
  urgency: 'urgent' | 'high' | 'normal' | 'low'
  status_label: string
  at: string | null
  due: string | null
  resource: string
}

export interface InboxList {
  items: InboxItem[]
  counts: Record<InboxTab, number>
  tab: InboxTab
  areas: Array<{ key: string; label: string }>
}

export const fetchInbox = (params: { tab: InboxTab; area?: string; agent?: string; q?: string }) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v) as Array<[string, string]>
  ).toString()
  return apiFetch<InboxList>(`${BASE}/inbox/?${qs}`)
}
